/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllEntityOrganizationTypes = require('../services/GetAllEntityOrganizationTypes');

var NonDepInternalEntityFormView = require('../views/NonDepInternalEntityFormView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetAllEntityOrganizationTypes())
    .done(function(entityOrganizationTypes) {
      NavUtils.navigate('nondep/entity/new');
      Scaffold.content.show(
        new NonDepInternalEntityFormView({
          model: new Backbone.Model({
            entityOrganizationTypes: entityOrganizationTypes
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
